export const arrayMenu = [
    {
        menu : 'New In',
        link : '/'
    },
    {
        menu : 'Furniture',
        link : '/furniture'
    },
    {
        menu : 'Magazine',
        link : '/magazine'
    },
    {
        menu : 'help',
        link : '/help'
    },
    {
        menu : 'Sign In',
        link : '/signin'
    }
];
